import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-salespoint',
    templateUrl: './salespoint.component.html',
    styleUrls: ['./salespoint.component.scss']
})
export class SalespointComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
